import { useContext } from 'react';

import { ElevationContext, type ElevationValue } from './context';

export function useElevation(): ElevationValue {
  const value = useContext(ElevationContext);
  if (!value) throw new Error('useElevation necesita ElevationProvider');
  return value;
}
